<div class="container">
  <h2 style="display:flex; justify-content:flex-start; align-items:center">
    <vng-icon name="keyboard_arrow_left" [outline]="false" (click)="nav.back()" style="cursor: pointer; margin-right: 10px; display: inline"
    ></vng-icon>
    <span style="font-weight: 700; font-size: 16px">Payment Details</span>
  </h2>

  <vng-card variant="outline">
    <div style="display:flex; justify-content:flex-start; gap:15px" class="payment-list-heading">
      <h2 flex="50">Saved Payment Methods</h2>
      <span class="spacer"></span>
      <button flex="50" (click)="addPaymentmethod()" class="text-center" vng-button variant="primary">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_2188_427"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2188_427)">
            <path d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z" fill="white" />
          </g>
        </svg>
        Add Payment Method
      </button>
    </div>
    <div style="display:flex; justify-content:center; align-items:center; gap:15px">
      <span class="text-heading">Payment</span>
      <span class="spacer"></span>
      <span class="text-heading">Subscription</span>
    </div>
  </vng-card>

  <vng-divider></vng-divider>

  <vng-empty-state *ngIf="paymentMethods.length < 1" title="Payment method not available"></vng-empty-state>
  <ul *ngIf="paymentMethods.length > 0">
    <li *ngFor="let paymentMethod of paymentMethods" style="display:flex; justify-content:center; align-items:center; gap:15px">
      <div style="display:flex; flex-direction:column; justify-content:center; align-items:center; gap:15px">
        <span style="display:flex">
          <ng-template *ngIf="paymentMethod.brand === 'visa'">
            <svg-icon-sprite width="28px" height="17px" src="icon-visa"> </svg-icon-sprite>
          </ng-template>
          <ng-template *ngIf="paymentMethod.brand === 'mastercard'">
            <svg-icon-sprite width="28px" height="17px" src="icon-mastercard"> </svg-icon-sprite>
          </ng-template>
          ****{{ paymentMethod.cardLastFour }}
        </span>
        <span style="display:flex; justify-content:flex-start; align-items:flex-end">
          {{ paymentMethod.cardExpiry }}
        </span>
      </div>
      <span class="spacer"></span>
      <div style="display:flex; flex-direction:column; gap:15px">
        <div style="display:flex; justify-content:flex-end; align-items:flex-end" class="payment-method-id">
          {{ "#" + paymentMethod.idx }}
        </div>
        <div style="display:flex; justify-content:space-evenly; align-items:center; gap:15px">
          <span *ngIf="paymentMethod.isPrimary === true" class="primary-payment-method">Primary</span>
          <button
            *ngIf="paymentMethod.isPrimary !== true"
            onclick="this.blur()"
            (click)="makePrimary(paymentMethod)"
            vng-button
            variant="primary"
          >
            Make Primary
          </button>
          <button class="remove-button" onclick="this.blur()" (click)="remove(paymentMethod)" vng-button variant="secondary">
            Remove
          </button>
        </div>
      </div>
    </li>
  </ul>
</div>
